import {
  extendsModule, baseFormGroup, registerMfModule, moduleKeys,
} from 'src/store/base';
import { INVENTORY_FLOW_MAP } from 'src/const/state/inventory-type';
import { shouldTikTokPlayableAdsUseable } from 'src/components/campaign/ad/playable/playableAdsEnable';
import { isSelfAccount } from 'src/const/state/transaction';
import { creativeMode } from 'src/const/state/creative';
import playableCreationFormItem from './playable-creation-form-item';

export default extendsModule(baseFormGroup, {
  state: {
    _moduleKey: 'playable-card-form-group',
    _formItems: moduleKeys([playableCreationFormItem]),
  },
  getters: {
    isVisible(state, getters, rootState, rootGetters) {
      const { appTypes } = rootState.creative.create;
      // // @deprecated
      // const useSplitTest = rootGetters['campaign/adgroup/useSplitTest'];
      let isAvailablePlacement;
      if (isSelfAccount() && !rootState.library.list.hasPlayableMaterial) {
        isAvailablePlacement = appTypes.length === 1 && appTypes[0] === INVENTORY_FLOW_MAP.TIKTOKADNETWORK.key;
      } else {
        isAvailablePlacement = appTypes.includes(INVENTORY_FLOW_MAP.TIKTOKADNETWORK.key) || appTypes.includes(INVENTORY_FLOW_MAP.ALL.key);
      }
      const isDpa = rootGetters['campaign/adgroup/isDpa'];
      const { isAppDownload } = getters.formState;
      const isSupportPanglePlayable = (isAvailablePlacement &&
        isAppDownload &&
        !isDpa // dpa支持pangle版位，但是不支持试玩
      );
      const isSupportTikTokPlayable = shouldTikTokPlayableAdsUseable({
        inventoryFlow: appTypes,
        objectiveType: rootState?.campaign?.adgroup?.objective_type,
        isAco: rootState?.campaign?.adgroup?.creative_material_mode === creativeMode.PROCEDURAL,
      });
      return isSupportPanglePlayable || isSupportTikTokPlayable;
    },
  },
  modules: registerMfModule([playableCreationFormItem]),
});
